import { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";

const CustomizedDropzon = ({
  onDrop,
  accept,
  multiple = false,
  maxSize,
  clearVideo,
}) => {
  const [files, setFiles] = useState([]);

  const onDropHandler = useCallback(
    (acceptedFiles) => {
      try {
        if (onDrop) {
          setFiles((prevFiles) => [...prevFiles, ...acceptedFiles]);
          onDrop(acceptedFiles);
        }
      } catch (error) {
        console.log(error);
      }
    },
    [onDrop]
  );

  const removeFile = (fileToRemove) => {
    setFiles((prevFiles) => prevFiles.filter((file) => file !== fileToRemove));
    clearVideo();
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: onDropHandler,
    accept: accept || {
      "video/mp4": [],
    },
    multiple: multiple,
    // maxSize: maxSize || 5242880,
  });

  return (
    <div
      {...getRootProps()}
      className={`upload-box ${isDragActive ? "file-upload-active" : ""}`}
    >
      <input {...getInputProps()} />
      <div className="upload-text-wrapper">
        {files.length === 0 && (
          <button type="button" className="upload-btn">
            Upload
          </button>
        )}
        {files.length > 0 && (
          <div className="file-previews">
            {files.map((file, index) => (
              <div key={index} className="file-preview">
                <video width="50" height="50" controls>
                  <source src={URL.createObjectURL(file)} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
                <button type="button" onClick={() => removeFile(file)}>
                  <svg
                    xmlns="http:www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-x"
                    viewBox="0 0 16 16"
                  >
                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                  </svg>
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
      {isDragActive && <div className="file-overlay"></div>}
    </div>
  );
};

export default CustomizedDropzon;
